import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface SettingsState {
  dateFormat: string;
  timeFormat: string;
  timezone: string;
  enableNotifications: boolean;
  gridSettings: {
    [gridId: string]: any; // AG Grid state
  };
}

const initialState: SettingsState = {
  dateFormat: 'MM/DD/YYYY',
  timeFormat: 'HH:mm:ss',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  enableNotifications: true,
  gridSettings: {},
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    updateSettings: (state, action: PayloadAction<Partial<SettingsState>>) => {
      return { ...state, ...action.payload };
    },
    setDateFormat: (state, action: PayloadAction<string>) => {
      state.dateFormat = action.payload;
    },
    setTimeFormat: (state, action: PayloadAction<string>) => {
      state.timeFormat = action.payload;
    },
    setTimezone: (state, action: PayloadAction<string>) => {
      state.timezone = action.payload;
    },
    setEnableNotifications: (state, action: PayloadAction<boolean>) => {
      state.enableNotifications = action.payload;
    },
    saveGridSettings: (state, action: PayloadAction<{ gridId: string; settings: any }>) => {
      state.gridSettings[action.payload.gridId] = action.payload.settings;
    },
    clearGridSettings: (state, action: PayloadAction<string>) => {
      delete state.gridSettings[action.payload];
    },
  },
});

export const {
  updateSettings,
  setDateFormat,
  setTimeFormat,
  setTimezone,
  setEnableNotifications,
  saveGridSettings,
  clearGridSettings,
} = settingsSlice.actions;

export default settingsSlice.reducer;